import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { InfoButtonDocument } from '../../models/infobutton-document';
import { InfoButtonImage } from '../../models/infobutton-image';
import { InfoButtonDisplayDTO } from '../../models/internal/infobutton-display-dto';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-infotooltip-dynamic',
  templateUrl: './infotooltip-dynamic.component.html',
  styleUrls: ['./infotooltip-dynamic.component.scss']
})
export class InfotooltipDynamicComponent implements OnInit {
  @Input() Id: number;
  @Output() private DynamicInfoIconClicked: EventEmitter<InfoButtonDisplayDTO> = new EventEmitter<InfoButtonDisplayDTO>();
  // @Input() infoTooltipText: string;
  @Input() infoButtonDisplayDTO: InfoButtonDisplayDTO;
  infoButtonImages: InfoButtonImage[] = [];
  ImagesAvailable: boolean = false;
  constructor(
    private dataService: DataService,
    private appSettings: AppSettings,
  ) { }

  ngOnInit() {
  }

  showToolTip() {
    const modal = document.getElementById('myModalInfoTip');
    modal.style.display = 'block';
    this.getInfoButton();
   
  }
  close() {
    const modal = document.getElementById('myModalInfoTip');
    modal.style.display = 'none';
  }

  getInfoButton()
  {
    // console.log("Getting info for info button id=" + this.Id);
    this.dataService
    .getInfoButton(this.Id)
    .subscribe((response: any) => {
        if (response != null && response.Data != null) {
            // this.infoTooltipText = response.Data.CustomText;
            this.infoButtonImages = response.Data.ImageInfo;
            this.infoButtonImages.forEach(x => {
              this.dataService.getInfoButtonImageFile(x).subscribe((y: any) => {
                if (y['Success'] == true) {
                  let extension = String(y['Data']['FileName']).split('.');
                  if (extension.length >= 2) {
                      x.DisplayUrl = 'data:image/' + extension[extension.length - 1] + ';base64,' + y['Data']['Base64String'];
                  } else {
                      x.DisplayUrl = 'data:image/png' + ';base64,' + y['Data']['Base64String'];
                  }
                }
              });
            });
            // this.ImagesAvailable = response.Data.ImageInfo.length > 0;
            var displayDTO = new InfoButtonDisplayDTO();
            // this.infoButtonDisplayDTO.CustomText = response.Data.CustomText;
            // this.infoButtonDisplayDTO.ImageInfo = response.Data.ImageInfo;
            // this.DynamicInfoIconClicked.emit(this.infoButtonDisplayDTO);
            displayDTO.CustomText = response.Data.CustomText;
            displayDTO.ImageInfo = response.Data.ImageInfo;
            displayDTO.DocumentInfo = response.Data.DocumentInfo;
            this.DynamicInfoIconClicked.emit(displayDTO);
        }
    });

  }

  getIfImagesAvailable() : boolean
  {
    return this.ImagesAvailable;
  }

  getImageURL(image: InfoButtonImage) {
    if (image.DisplayUrl == undefined || image.DisplayUrl == null || image.DisplayUrl === '') {
        return image.UUId;
    } else {
        return image.DisplayUrl;
    }
}


getInfoDocumentURL(doc: InfoButtonDocument) {
  return this.appSettings.Packaging2APIUrl +
  '/InfoButtonDocument/InfoButtonDocument/?InfoButtonDocumentId=' +
  doc.Id;
}


}
